<template>
  <div class="pe-option-container">
    <SearchableSelect 
      v-if="masterOption && !hasSelection"
      :options="[]" 
      :searchFunction="performSearch"
      :debounceDelay="debounceMs"
      :selected="selectedItem"
      :filter-keys="['label']" 
      placeholderKey="label"
      :defaultPlaceholder="'Escribí para buscar...'" 
      @select="handleSelect" 
    />
    
    <div v-if="hasSelection" class="pe-ListOptions">
      <div @click="removeItem()" class="pe-ListItem">
        <p :class="[globalConfig.classes?.input]">{{ selectedItem.label }}</p>
        <span class="pe-delete-icon">✕</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import SearchableSelect from '../Shared/SearchableSelect.vue';

const props = defineProps({
  question: { type: Object, required: true },
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

// 1. Opciones disponibles genéricas generadas por el Motor (Group)
const asyncOptions = computed(() => {
  return props.question.optionGroups['async_data'] || [];
});

const masterOption = computed(() => {
  return asyncOptions.value[0];
});

const debounceMs = computed(() => {
  return masterOption.value?.dataset_config?.debounce_ms || 300;
});

const selectedItem = ref(null);

// Mapeo inicial si el Backend ya pre-cargó esta respuesta (ej. al revisar un trámite o cargar borrador)
if (masterOption.value && masterOption.value.value) {
    selectedItem.value = {
        value: masterOption.value.value, 
        label: masterOption.value.value
    };
    
    // Auto-recuperación de precio si fue reiniciado y perdimos el RAM Cache
    if (!masterOption.value.price_modifier) {
        performSearch(masterOption.value.value).then(res => {
            const match = res.find(r => r.label === masterOption.value.value);
            if (match && match.price_modifier !== undefined) {
                selectedItem.value = match;
                engine.setAnswer(props.question.id, masterOption.value.id, match.label, match.price_modifier);
            }
        }).catch(err => console.error("Error auto-hydrating async price:", err));
    }
}

const hasSelection = computed(() => !!selectedItem.value);

// Búsqueda asíncrona usando la API externa proveída por el ApiAdapter Frontend
const performSearch = async (query) => {
  console.log("entra perform", engine.apiAdapter)
  if (!engine.apiAdapter || !engine.apiAdapter.searchAsyncData) {
      console.warn("[ProceduresEngine] No 'searchAsyncData' method provided in ApiAdapter.");
      return [];
  }
  console.log("no pasa el if")
  if (!masterOption.value || !query || query.trim() === "") return [];

  console.log("supuestamente llama")
  return await engine.apiAdapter.searchAsyncData(masterOption.value.id, query);
};

// Acciones
const handleSelect = (item) => {
  if (!masterOption.value) return;
  selectedItem.value = item;
  
  // Guardamos el LABEL formateado y el Precio exacto calculado por el backend
  engine.setAnswer(props.question.id, masterOption.value.id, item.label, item.price_modifier);
};

const removeItem = () => {
  if (!masterOption.value) return;
  selectedItem.value = null;
  // Al remover reseteamos el precio a 0 indirectamente
  engine.setAnswer(props.question.id, masterOption.value.id, null, 0);
};
</script>

<style scoped>
.pe-ListOptions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 5px;
}

.pe-ListItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: #f5f5f5;
  border-radius: var(--pe-input-border-radius, 0.5rem);
  padding: var(--pe-qo-select-list-item-padding, 0.75vw);
  cursor: pointer;
  gap: var(--pe-options-gp, 1.5vh);
  background: var(--pe-selected-item-bg, #F5F5F5);
  transition: background 0.2s;
  width: 100%;
}

.pe-ListItem:hover {
  background: var(--pe-selected-item-hover-bg, #e0e0e0);
}

.pe-ListItem p {
  margin: 0;
  color: var(--pe-input-text-color, #333);
}

.pe-delete-icon {
  font-weight: bold;
  color: var(--pe-delete-icon-color, #666);
}

.pe-delete-icon:hover {
  color: var(--pe-error-color, #ff4d4f);
}
</style>
